import { useCallback, useRef } from 'react';
import { pauseFor } from '@/common/utils/async';
import useMountedState from './useMountedState';

export const usePolling = <R = void>(maxRetries?: number) => {
  const isMounted = useMountedState();
  const retryRef = useRef(0);
  const poll = useCallback(
    async (
      validator: () => Promise<R>,
      retryInterval = 2000
    ): Promise<R | void> => {
      try {
        retryRef.current += 1;
        return await validator();
      } catch (err) {
        if (!isMounted()) {
          throw new Error();
        }
        if (maxRetries && retryRef.current >= maxRetries) {
          return Promise.resolve();
        }

        await pauseFor(retryInterval);
        return await poll(validator, retryInterval);
      }
    },
    [isMounted, maxRetries]
  );

  return poll;
};

export default usePolling;
